import React from "react";
import { useSelector } from "react-redux";
import {
  getContent,
  getRightContent,
  getVisibleSensorAnimation,
} from "../assets/js/utils";
import ContentTitle from "./ContentTitle";
import CustomReadMore from "./CustomReadMore";

import tanmiahPillarsImage from "../assets/images/tanmiah-pillars.png";
import tanmiahPillarsImageArabic from "../assets/images/tanmiah-pillars-arabic.png";
import useKeyPropRtlLanguage from "./hooks/useKeyPropRtlLanguage";
import ReactVisibilitySensor from "react-visibility-sensor";
import CustomReadMoreTitle from "./CustomReadMoreTitle";

function Content9(props) {
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  const sections = useSelector((state) => state.ui.sections);
  const keyAnimationRestartWhenChangeLanguage = useKeyPropRtlLanguage();
  return (
    <div key={keyAnimationRestartWhenChangeLanguage}>
      <div className="general-m">
        <div className="content-8__sticky-container">
          <div className="content-8__title-container">
            <ContentTitle
              label={getRightContent(
                generalSettings.rtlLanguage,
                getContent().sections[sections.currentSection].content.title
              )}
            />
          </div>
          <div className="content-8__text-container mt-40-70">
            <CustomReadMore
              text={getRightContent(
                generalSettings.rtlLanguage,
                getContent().sections[sections.currentSection].content
                  .customReadMore1.text
              )}
              textComplement={getRightContent(
                generalSettings.rtlLanguage,
                getContent().sections[sections.currentSection].content
                  .customReadMore1.complement
              )}
            />

            <CustomReadMoreTitle
              title={getRightContent(
                generalSettings.rtlLanguage,
                getContent().sections[sections.currentSection].content
                  .titleH2CustomReadMore2
              )}
              applyClassName={"color-secondary"}
            />
            <CustomReadMore
              text={getRightContent(
                generalSettings.rtlLanguage,
                getContent().sections[sections.currentSection].content
                  .customReadMore2.text
              )}
              textComplement={getRightContent(
                generalSettings.rtlLanguage,
                getContent().sections[sections.currentSection].content
                  .customReadMore2.complement
              )}
              applyReadMoreTogglerClassName="color-white"
            />

            <CustomReadMoreTitle
              title={getRightContent(
                generalSettings.rtlLanguage,
                getContent().sections[sections.currentSection].content
                  .titleH2CustomReadMore3
              )}
              applyClassName={"color-secondary"}
            />
            <CustomReadMore
              text={getRightContent(
                generalSettings.rtlLanguage,
                getContent().sections[sections.currentSection].content
                  .customReadMore3.text
              )}
              textComplement={getRightContent(
                generalSettings.rtlLanguage,
                getContent().sections[sections.currentSection].content
                  .customReadMore3.complement
              )}
              applyReadMoreTogglerClassName="color-white"
            />
          </div>
        </div>

        <div className="general-separator"></div>
        <ReactVisibilitySensor partialVisibility>
          {({ isVisible }) => (
            <img
              src={
                generalSettings.rtlLanguage
                  ? tanmiahPillarsImageArabic
                  : tanmiahPillarsImage
              }
              alt="tanmiah-pillars"
              className="content-8__pillars-image"
              style={getVisibleSensorAnimation(
                isVisible,
                "fade-in-40px-scale 1.5s backwards"
              )}
            />
          )}
        </ReactVisibilitySensor>
        <div className="general-separator"></div>
      </div>
    </div>
  );
}

export default Content9;
